import React, { ReactNode, useState, useCallback } from "react";
import Accodion from "src/assets/images/accodion.svg";
import AccodionActive from "src/assets/images/accodionActive.svg";
import cn from "classnames";
import styled from "styled-components";

interface IAccodionProps {
  title: string;
  subTitle?: string;
  children: ReactNode;
}

const Accordion = (props: IAccodionProps) => {
  const parentRef = React.useRef<HTMLDivElement>(null);
  const childRef = React.useRef<HTMLDivElement>(null);
  const [isActive, setActive] = useState(false);

  const toggleAccodion = useCallback(() => {
    if (parentRef.current === null || childRef.current === null) {
      return;
    }
    if (parentRef.current.clientHeight > 0) {
      parentRef.current.style.height = "0";
    } else {
      parentRef.current.style.height = `${childRef.current.clientHeight}px`;
    }
    setActive(!isActive);
  }, [isActive]);

  return (
    <AccordionSet>
      <div className={cn({ active: isActive })}>
        <div className="accodion-title" onClick={toggleAccodion}>
          <div className="title">{props.title}</div>
          {props.subTitle && <div className="sub-title">{props.subTitle}</div>}
        </div>
        <div className="accodion-content" ref={parentRef}>
          <div ref={childRef}>{props.children}</div>
        </div>
      </div>
    </AccordionSet>
  );
};

const AccordionSet = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.color.linePrimary};
  > div {
    .accodion-title {
      ${({ theme }) => theme.flexBox.flexMixin()}
      padding: 15px 30px 15px 0;
      background-image: url(${Accodion});
      background-repeat: no-repeat;
      background-position: 100% 50%;
      font-size: 16px;
      line-height: 20px;
      cursor: pointer;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
      &:focus {
        border: none;
        outline: none;
      }
      .title {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .sub-title {
        font-family: "Poppins";
        font-weight: 500;
      }
    }
    .accodion-content {
      overflow: hidden;
      height: 0;
      padding-right: 30px;
      border-top: none;
      transition: height 0.35s ease-in-out;
    }
    &.active {
      .accodion-title {
        background-image: url(${AccodionActive});
      }
      .accodion-content {
        height: auto;
        border-top: 1px solid ${({ theme }) => theme.color.linePrimary};
      }
    }
  }
  &:last-child {
    border-bottom: none;
  }
`;

export default Accordion;
